import { WHATSAPP_NUMBER } from "@/lib/api";

export const WhatsAppButton = () => {
  const href = `https://wa.me/91${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi Spherio Living! I'd like to know more about your home interior services."
  )}`;
  return (
    <a
      data-testid="whatsapp-float-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[60] flex items-center gap-3 rounded-full bg-[#25D366] pl-4 pr-5 py-3 text-white shadow-lg shadow-black/20 transition-transform duration-300 hover:scale-105 active:scale-95"
    >
      <svg viewBox="0 0 32 32" className="h-6 w-6 fill-white" aria-hidden="true">
        <path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.1 1.6 5.9L4 29l8.3-1.6c1.7.9 3.6 1.4 5.7 1.4 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-4.9 1 1-4.8-.3-.4C5.5 18.9 5 17 5 15 5 8.9 9.9 4 16 4s11 4.9 11 11-4.9 9.8-11 9.8zm6.1-7.3c-.3-.2-1.9-.9-2.2-1s-.5-.2-.7.2-.8 1-1 1.2-.4.2-.7.1c-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-2-1.8-2.3s0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.5s0-.4 0-.6c-.1-.2-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4s-1.1 1-1.1 2.5 1.1 2.9 1.3 3.1c.2.2 2.2 3.4 5.4 4.8.7.3 1.3.5 1.8.6.7.2 1.4.2 1.9.1.6-.1 1.9-.8 2.1-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z" />
      </svg>
      <span className="hidden sm:inline text-sm font-semibold">Chat with us</span>
    </a>
  );
};
